import React from "react";
import AccommodationCard from "../components/accomodationCard";
import protea_hotel from  '../images/accomadations/protea-hotel.jpg'
import Nare from '../images/accomadations/Nare.jpg'
function AccommodationList() {
  const accommodations = [
    {
      name: "Protea Hotel",
      location: "5 minutes from Mittah Seperepere Convention Centre",
      description: "A luxury hotel with all the amenities you need.",
      image: protea_hotel,
    },
    {
      name: "Nare hotel",
      location: "10 minutes from Mittah Seperepere Convention Centre",
      description: "Cozy and affordable guesthouse for families.",
      image:  Nare,
    },
    {
      name: "Lodge C",
      location: "15 minutes from Mittah Seperepere Convention Centre",
      description: "A peaceful retreat surrounded by nature.",
      image: "path_to_lodge_c_image.jpg",
    },
    {
      name: "Hotel D",
      location: "7 minutes from Mittah Seperepere Convention Centre",
      description: "Modern hotel with excellent amenities.",
      image: "path_to_hotel_d_image.jpg",
    },
  ];

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Accommodations Near Mittah Seperepere Convention Centre</h2>
      <div className="row">
  {accommodations.map((accommodation, index) => (
    <div className="col-md-6 col-lg-3 mb-4" key={index}>
      <AccommodationCard {...accommodation} />
    </div>
  ))}
</div>

    </div>
  );
}

export default AccommodationList;
